import Http from "@/config/axios.js"
import {to} from "await-to-js"

export default {
    async order(order, params) {
        return to(Http.post( process.env.VUE_APP_LAYER_API_URL + `order/${order}`, params))
    },
}